import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { compose, assocPath, call } from 'ramda';
import { withProps } from 'recompose';

import LocalizedLink from 'app/features/localization/components/LocalizedLink/LocalizedLink';
import S from 'app/components/HeroBlock/HeroBlock.styled';
import Heading from 'app/components/layout/Heading.styled';
import Text from 'app/components/layout/Text.styled';
import connect from 'app/libs/connect';
import { homeSelected } from 'app/features/header/actions';

const UI = ({ titleKey, subtitleKey, buttons, image }) => (
  <S.HeroBlock>
    <S.HeroBlock.Content data-t="hero-block">
      <Heading size="xl" as={S.HeroBlock.Content.Title} type="heavy">
        <FormattedMessage
          id={titleKey}
          values={{ linebreak: <S.HeroBlock.Content.Title.Linebreak /> }}
        />
      </Heading>
      <Text as={S.HeroBlock.Content.Subtitle} size="xl">
        <FormattedMessage
          id={subtitleKey}
          values={{ linebreak: <S.HeroBlock.Content.Subtitle.Linebreak /> }}
        />
      </Text>
      <S.HeroBlock.ButtonHolder>
        {Object.entries(buttons).map(([key, { textKey, ...rest }]) => (
          <S.HeroBlock.Button key={key} as={LocalizedLink} {...rest}>
            <FormattedMessage id={textKey} />
          </S.HeroBlock.Button>
        ))}
      </S.HeroBlock.ButtonHolder>
    </S.HeroBlock.Content>
    <S.HeroBlock.ImageHolder>
      <S.HeroBlock.Image
        data-t="hero-image"
        src={`${window.etp.config.assetsUrl}${image.imageUrl}`}
        srcSet={`${window.etp.config.assetsUrl}${image.image2XUrl} 2x`}
        alt="Hime"
      />
    </S.HeroBlock.ImageHolder>
  </S.HeroBlock>
);

UI.propTypes = {
  image: PropTypes.shape({
    imageUrl: PropTypes.string.isRequired,
    image2XUrl: PropTypes.string.isRequired,
  }).isRequired,
  titleKey: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string.isRequired,
  buttons: PropTypes.objectOf(
    PropTypes.shape({
      textKey: PropTypes.string.isRequired,
      to: PropTypes.string,
      type: PropTypes.string,
    }),
  ),
};

UI.defaultProps = { buttons: {} };

const assocButtonOnClick = props =>
  assocPath(['buttons', '0', 'onClick'], () => call(props.homeSelected), props);

const HeroBlock = compose(
  connect(null, { homeSelected }),
  withProps(assocButtonOnClick),
)(UI);

export { UI, assocButtonOnClick };

export default HeroBlock;
